// extracted by mini-css-extract-plugin
export default {"element":"ComingSoon_element__qLChM"};